import { useIntl } from '@grandvisionhq/state';
import { useWishlistId } from '@grandvisionhq/svc-wishlist';
import { useGetAnonWishlist } from './use-get-anon-wishlist.js';
import { useGetUserWishlist } from './use-get-user-wishlist.js';
import { useWishlistAuthState } from './use-wishlist-auth-state.js';

const useGetWishlist = ()=>{
    const { locale  } = useIntl();
    const { isAuthLoading , isUserLoggedIn  } = useWishlistAuthState();
    const { localWishlist , clearWishlist  } = useWishlistId();
    const userWishlist = useGetUserWishlist({
        locale,
        isAuthLoading,
        isUserLoggedIn
    });
    const anonWishlist = useGetAnonWishlist({
        locale,
        isAuthLoading,
        isUserLoggedIn,
        localWishlist,
        clearWishlist
    });
    const isLoading = isAuthLoading || (isUserLoggedIn ? userWishlist.loading : anonWishlist.loading);
    const error = isAuthLoading ? null : isUserLoggedIn ? userWishlist.error : anonWishlist.error;
    const data = isAuthLoading ? null : isUserLoggedIn ? userWishlist.data : anonWishlist.data;
    useWishlistId(isUserLoggedIn ? userWishlist.refetch : anonWishlist.refetch);
    return {
        data,
        loading: isLoading,
        error: error !== null && error !== void 0 ? error : null
    };
};

export { useGetWishlist };
//# sourceMappingURL=use-get-wishlist.js.map
